<div style="width: 100%">
  <div fxLayout="column" fxLayoutGap="10px" fxFlex="100" class="column-regioes">
    <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="center">
      <div>
        <div>
          <div fxFlex="35" class="header-label-qtd-projs text-start">Local</div>
          <div fxFlex="10" class="header-label-qtd-projs text-end">Projetos</div>
          <div fxFlex="55" class="header-label-qtd-projs text-end">Municípios</div>
        </div>
      </div>
      <div>
        <div fxLayout="row">
          <span fxFlex="35" class="text-start" id="label-brasil">Brasil</span>
          <span fxFlex="10" class="text-end" id="qtd-total-projs-brasil">{{totalProjRegBr.totalProjetosBr}}</span>
          <span fxFlex="55" class="text-end" id="qtd-total-municipios-projetos">{{totalProjRegBr.totalMunicipiosComProjetos}}</span>
        </div>
      </div>
      @for (regiao of totalProjRegBr.regioesProjCount; track regiao) {
        <div class="regiao-item">
          <div fxFlex="40" fxLayout="column">
            <div fxLayout="row">
              <span fxFlex="66" class="label-regiao text-start" [ngClass]="gerarClasseRegiaoCustom(regiao.regiao)">{{regiao.regiao}}</span>
              <span fxFlex="34" class="total-proj-regiao text-end" [ngClass]="gerarClasseRegiaoCustom(regiao.regiao)">{{regiao.totalProjetos}}</span>
            </div>
            <div fxLayout="column" fxLayoutGap="10px" class="" fxFlex="100">
              <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="center">
                @for (estado of regiao.projetosEstado; track estado) {
                  <div class="-body-estado">
                    <span fxFlex="66" class="label-estado text-start">{{estado.estado}}</span>
                    @if (estado.qtdProjetos > 0) {
                      <span fxFlex="34" class="total-proj-estado text-end">{{estado.qtdProjetos}}</span>
                    }
                    @if (estado.qtdProjetos == 0) {
                      <span fxFlex="34" class="total-proj-estado text-end">-</span>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <div fxFlex="60" class="container-porcentagem-nacional">
            <div class="container-pine">
              <canvas [id]="gerarClasseRegiaoCustom(regiao.regiao)" [ngClass]="gerarClasseRegiaoCustom(regiao.regiao)" width="98" height="98"></canvas>
            </div>
            <div class="container-percent">
              <span class="total-proj-regiao-percent text-center" [ngClass]="gerarClasseRegiaoCustom(regiao.regiao)">{{regiao.percentualBr | number: '1.0-2'}}%</span>
              <span class="subtexto-percent">dos projetos</span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>